import request from '@/utils/request'
// 查询维修区域列表分页
export function fetchMasterList(query) {
    return request({
        url: '/system/user/page',
        method: 'get',
        params: query,
    })
}

export function putObj(data) {
    return request({
        url: '/upkeep/order/master/add',
        method: 'post',
        data,
    })
}
